import React from "react"
import moment from "moment-timezone"

export const adminName = row => [row.firstName, row.lastName].filter(Boolean).join(" ") || "Unnamed admin"
export const adminRole = role => role === "superAdmin" ? "Super admin" : role === "admin" ? "Admin" : "Not specified"
export const canManageAdmins = user => user?.role === "superAdmin" && user?.status === "activated"
export const adminStatus = status => <span className={"badge badge-soft-" + (({ activated: "success", pending: "warning", blocked: "danger", deleted: "secondary" })[status] || "secondary")}>
  {({ activated: "Activated", pending: "Pending", blocked: "Blocked", deleted: "Deleted" })[status] || "Not specified"}
</span>
export const adminCreatedAt = (value, timezone = false) => value && moment(value).isValid()
  ? <div className="admin-cell"><span>{moment(value).tz("Europe/Bucharest").format("DD MMM YYYY")}</span>
    <small className="text-muted">{moment(value).tz("Europe/Bucharest").format("HH:mm")}{timezone && " · Europe/Bucharest"}</small></div>
  : <span className="text-muted">Not provided</span>
export const adminEmail = row => {
  const email = row.status === "deleted" ? row.email?.replace(/(?:-deleted)+$/i, "") : row.email
  if (!email) return <span className="text-muted">Not provided</span>
  return <div className="admin-cell">
    {row.status !== "deleted" && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
      ? <a href={"mailto:" + encodeURIComponent(email)}>{email}</a> : <span>{email}</span>}
    {row.status === "deleted" && <small className="text-muted">Former email</small>}
  </div>
}
export const adminStatusDescription = status => ({
  activated: "The account is active and can sign in with valid credentials.",
  pending: "Awaiting account activation. Pending status does not itself prevent sign-in in the current system.",
  blocked: "Access is blocked. The account is retained and can be activated again by a super admin.",
  deleted: "Access is revoked and the account record is retained in the history. This page is read-only.",
})[status] || "The account status is not available."
